import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';

export default function DataTableServerSidePagination(props) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCountState` from being undefined during the loading
  const [rowCountState, setRowCountState] = useState(
    props.pageState?.total || 0
  );
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      props.pageState?.total !== undefined
        ? props.pageState?.total
        : prevRowCountState
    );

    props.GetDataFromAPi(paginationModel);
  }, [paginationModel]);

  React.useEffect(() => {
    props.GetDataFromAPi(paginationModel);
  }, []);

  const queueManagementData = props.queueManagementData;
  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={props.rows}
        columns={props.columns}
        rowCount={props.pageState.total}
        loading={props.isLoading}
        pageSizeOptions={[5, 10, 15, 20]}
        paginationModel={paginationModel}
        paginationMode='server'
        onPaginationModelChange={setPaginationModel}
        checkboxSelection={false}
        disableRowSelectionOnClick
        onRowSelectionModelChange={(ids) => {
          props.getselectedData(ids);
          // props.setSelectedRows(ids);
        }}
        rowSelectionModel={props.selectedRows}

      // keepNonExistentRowsSelected={true}
      // onPageChange={(newPage) =>
      //     setpageState((old) => ({ ...old, page: newPage + 1 }))
      // }
      // onPageSizeChange={(newPageSize) =>
      //     setpageState((old) => ({ ...old, pageSize: newPageSize }))
      // }
      />
    </div>
  );
}
